import React from "react";
import "./todayEvent.style.scss";

const TodayEvent = ({ eventTime, eventTitle, uniqueId, eventNumber, totalEvents, challengeTitle, index, boolean, onHandleClick, challengeIndex }) => {

    return (
        <div
            className={`today-event${boolean === true ? `-done` : ''}`}
            onClick={() => onHandleClick(challengeIndex, eventNumber)}
        >
            <div className="time-text">
                <p className="small-text">{eventTime}</p>
            </div>
            <div className="today-event-info">
                <p className="title">{eventTitle}</p>
                <p className="subtitle">
                    {challengeTitle} · {eventNumber} of {totalEvents}
                </p>
            </div>
            {
                boolean === true ? (
                    <div className="done-check-true">
                        <p>✓</p>
                    </div>
                ) : (
                    <div className="done-check">
                        <p></p>
                    </div>
                )
            }
        </div>
    );
};

export default TodayEvent;